/*
 * FusionMsiFaviconManager — applies the FusionMSI favicon + social meta on
 * FusionMSI / DecisionPoint pages (and restores prior head tags on leave).
 *
 * Mounted once inside the Router (so it can read the active location). index.html
 * already ships the FusionMSI favicon; this manager re-applies it after other
 * brand managers (e.g. VoxPont) and sets og/twitter social-image meta. Mirrors
 * VoxPontFaviconManager.
 */

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { applyFusionMsiBranding } from "../marketing/fusionMsiBranding";
import { isFusionMsiBrandedPath } from "../marketing/fusionMsiMarketingRouting";

export default function FusionMsiFaviconManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!isFusionMsiBrandedPath(pathname)) return undefined;
    // applyFusionMsiBranding returns a cleanup that restores the prior head tags.
    return applyFusionMsiBranding();
  }, [pathname]);

  return null;
}
